import { relativeRowToRowId, rowTypeFromPeriod, standardizeMonthCode } from "@package/grid-utils";

import { splitCellRef } from "../formatting/cell-ref";

export const parseAlertLimit = (limitRef: string) => {
  const value = Number(limitRef);
  if (Number.isFinite(value)) return { type: "value" as const, value };
  const parsed = splitCellRef(limitRef);
  const rawPeriod = parsed?.period;
  // Legacy limit refs stored relative rows (e.g. "REL-M5"); resolve them to
  // the absolute period they represent today. New refs store the period directly.
  const absolutePeriod = rawPeriod?.startsWith("REL-") ? (relativeRowToRowId[rawPeriod] ?? rawPeriod) : rawPeriod;
  const rowType = rowTypeFromPeriod(absolutePeriod ?? "");
  const rowId = standardizeMonthCode(absolutePeriod ?? "");
  return {
    type: "ref" as const,
    columnId: parsed?.columnId ?? "",
    productId: parsed?.productId ?? "",
    fieldSelector: parsed?.fieldSelector ?? "",
    rowType,
    rowId,
    /** Absolute period (or strip formula) for calc-store lookup. `rowId` may be a month code. */
    period: absolutePeriod ?? "",
  };
};
